import { PRIVILEGED_LOGIN_STORAGE_KEY } from "./constants";

/**
 * Marks the current uid as a privileged / non-user-initiated login
 * (master password or owner login-as-client). Used to skip lastLogins, etc.
 */
export const setPrivilegedLoginInStorage = ({ uid }) => {
  if (!uid) {
    return;
  }

  try {
    localStorage.setItem(PRIVILEGED_LOGIN_STORAGE_KEY, uid);
  } catch (error) {
    console.log(error);
  }
};

export const clearPrivilegedLoginFromStorage = () => {
  try {
    localStorage.removeItem(PRIVILEGED_LOGIN_STORAGE_KEY);
  } catch (error) {
    console.log(error);
  }
};

export const isPrivilegedLoginFromStorage = ({ uid }) => {
  if (!uid) {
    return false;
  }

  try {
    return localStorage.getItem(PRIVILEGED_LOGIN_STORAGE_KEY) === uid;
  } catch (error) {
    console.log(error);
    return false;
  }
};
